export const mockTeamData = [
  {
    name: "Thomas Brunner",
    image: "/images/tb.jpg",
    description: "Es begeistert mich, wenn dank meinen Impulsen ein Team sein Potential entfaltet und festsitzende Digitalisierungsprojekte wieder Fahrt aufnehmen, wenn die Musik meiner Band Menschen glücklich macht, und wenn meine Routen Radfahrer*innen zu unvergesslichen Gravel-Rides inspirieren.",
    linkedinUrl: "https://www.linkedin.com/in/thomas-brunner-basel/",
    additionalLink: {
      text: "The Urban Country Club",
      url: "https://www.tucc.ch/"
    },
    contactEmail: "mailto:tb@emdash.ch"
  },
  {
    name: "Patrick Püntener",
    image: "/images/pp.jpg",
    description: "Intuition, Überzeugung und Wissen sind für mich die drei wichtigsten Zutaten für alles, was ich im Leben anpacke. Wie man mit diesem einfachen Rezept Ideen, Strategien und Digitalisierungsvorhaben erfolgreich umsetzt, gebe ich gerne weiter.",
    linkedinUrl: "https://www.linkedin.com/in/patrickpuntener/",
    contactEmail: "mailto:pp@emdash.ch"
  },
  {
    name: "Matthias Walter",
    image: "/images/mw.jpg",
    description: "Die betriebliche Umsetzung von Software-Entwicklung und Systems-Engineering ist mein Spezialgebiet. Als Unternehmer, Gründer und CFO in der Softwarebranche bringe ich ein fundiertes Knowhow in Management und Business Development mit, auch wenn meine Passion Technologie-Strategie bleibt.",
    linkedinUrl: "https://www.linkedin.com/in/matthias-walter-basel/",
    contactEmail: "mailto:mw@emdash.ch"
  }
];